import { render } from "./MobileFooter.vue?vue&type=template&id=406988d3&scoped=true"
import script from "./MobileFooter.vue?vue&type=script&lang=js"
export * from "./MobileFooter.vue?vue&type=script&lang=js"

import "./MobileFooter.vue?vue&type=style&index=0&id=406988d3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406988d3"]])

export default __exports__